export default __webpack_public_path__ + "376ff26eb5d2ba725c42a4d25bb900c4.png";